// Default configuration - can be overridden by environment variables
const defaultConfig = {
	development: {
		apiBaseUrl: "http://localhost:3002",
		authBaseUrl: "http://localhost:3002",
	},
	staging: {
		apiBaseUrl: "https://gcpmvp.curohq.com",
		authBaseUrl: "https://gcpmvp.curohq.com",
	},
	production: {
		apiBaseUrl: "https://prodapi.curohq.com",
		authBaseUrl: "https://prodapi.curohq.com",
	},
};

// Function to determine environment
function getEnvironment(): keyof typeof defaultConfig {
	// Check for explicit environment variable (for local dev and Cloudflare)
	const envVar = import.meta.env.PUBLIC_ENV__API_HOST;
	if (envVar && envVar in defaultConfig) {
		return envVar as keyof typeof defaultConfig;
	}

	// Auto-detect based on URL for Cloudflare deployments
	if (typeof window !== "undefined") {
		const hostname = window.location.hostname;

		// Production domains
		if (
			hostname.includes("curohq.com") &&
			!hostname.includes("staging") &&
			!hostname.includes("dev")
		) {
			return "production";
		}

		// Staging domains (adjust pattern based on your staging URL)
		if (hostname.includes("staging") || hostname.includes("dev")) {
			return "staging";
		}

		// Cloudflare Pages preview URLs
		if (hostname.includes("pages.dev")) {
			// You can customize this logic based on your branch naming
			// For example, if production branch deploys have a specific pattern
			return "staging";
		}
	}

	// Default fallback
	return "development";
}

// Get configuration with environment variable overrides
function getConfig() {
	const env = getEnvironment();
	const baseConfig = defaultConfig[env];

	return {
		apiBaseUrl:
			import.meta.env.PUBLIC_ENV__API_BASE_URL || baseConfig.apiBaseUrl,
		authBaseUrl:
			import.meta.env.PUBLIC_ENV__AUTH_BASE_URL || baseConfig.authBaseUrl,
	};
}

export const currentConfig = getConfig();

export const getApiUrl = (path: string) => `${currentConfig.apiBaseUrl}${path}`;
export const getAuthUrl = (path: string) =>
	`${currentConfig.authBaseUrl}${path}`;
